import { getCookie, setCookie } from 'util/cookie-utils'

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365
const SR_LAST_SEEN_DATE_COOKIE_NAME = 'TT_SRLSD' // SR: Seller Rating


function setLastSeenSellerRatingDate() {
  // setting to now in milliseconds UTC, expiring in a year
  setCookie(SR_LAST_SEEN_DATE_COOKIE_NAME, Date.now(), ONE_YEAR_SECONDS)
}

function getLastSeenSellerRatingDate() {
  return getCookie(SR_LAST_SEEN_DATE_COOKIE_NAME)
}

export default { getLastSeenSellerRatingDate, setLastSeenSellerRatingDate }
